import Invoice from "../components/pages/InvoicePage"
import Payment from "../components/pages/PaymentPage";
import Main from "../components/col-mainComp"
import Result from "../components/pages/Result";
import Faq from "../components/pages/FaqPage";
import NotFound from "../components/NotFound";

const routesConfig = [
    {
        path: "/",
        exact: true,
        component: Main,
        breadcrumb: "Ana Sayfa"
    },
    {
        path: "/invoice",
        exact: true,
        component: Invoice,
        breadcrumb: "Fatura"
    },
    {
        path: "/payment/:corpCode/:invoiceNo",
        exact: true,
        component: Payment,
        breadcrumb: "Ödeme"
    },
    {
        path: "/result",
        exact: true,
        component: Result,
        breadcrumb: "İşlem Sonucu"
    },
    {
        path: "/not-found",
        exact: true,
        component: NotFound,
        breadcrumb: "Not Founds"
    },
    {
        path: "/faq",
        exact: true,
        component: Faq,
        breadcrumb: "Sıkça Sorulan Sorular"
    },
];

export default routesConfig;